import star from '../../assets/icons/yellow-star.png'

const AverageRaitingBox = ({ doctor }) => {
    return (
        <div className='w-2/5'>
            <div className='flex justify-center'>
                <div className='relative w-28 h-28'> {/* سایز ستاره را ثابت کنید */}
                    <img
                        src={star}
                        className='w-full h-full object-contain'
                        alt="star"
                    />
                    <span
                        className='absolute top-1/2 left-1/2
                        transform -translate-x-1/2 -translate-y-1/2
                        text-white text-[25px] bottom-8'
                    >
                        {doctor.score}
                    </span>
                </div>
            </div>
            <div className='flex flex-col items-center mt-2'>
                <p className='font-medium'>
                    میانگین امتیاز
                </p>
                <p className='flex gap-1'>
                    <span>از</span>
                    <span>{doctor.comments}</span>
                    <span>دیدگاه</span>
                </p>
            </div>
        </div>
    )
}

export default AverageRaitingBox
